export var MultiStatusBannerStatus;

(function (MultiStatusBannerStatus) {
  MultiStatusBannerStatus[MultiStatusBannerStatus["initial"] = 0] = "initial";
  MultiStatusBannerStatus[MultiStatusBannerStatus["loading"] = 1] = "loading";
  MultiStatusBannerStatus[MultiStatusBannerStatus["success"] = 2] = "success";
  MultiStatusBannerStatus[MultiStatusBannerStatus["error"] = 3] = "error";
})(MultiStatusBannerStatus || (MultiStatusBannerStatus = {}));